export enum FormControlValidatorEnum {
    REQUIRED = 'required',
    MAX_LENGTH = 'maxlength',
    MIN_LENGTH = 'minlength',
    MIN = 'min',
    MAX = 'max',
}
